import React,{useEffect, useState} from 'react'
import { useSwipeable } from 'react-swipeable';
import Brick from './Brick'
import TextGlobe from './TextGlobe';

const Board = ({ laberinto, onWin, pendingMsg, appSize, objFound }) => {

    const [charPos, setCharPos] = useState(0);
    const [laberintoObjects, setLaberintoObjects] = useState([]);
    const [faltanObjetos, setFaltanObjetos] = useState(false)

    const objectNames = [
      laberinto.obj1_nombre,
      laberinto.obj2_nombre,
      laberinto.obj3_nombre,
      laberinto.obj4_nombre,
      laberinto.obj5_nombre,
      laberinto.obj6_nombre
    ]
    const board = JSON.parse(laberinto.board);
    
    

    const boardStyle = {
      height: appSize[0] < appSize[1] ? `${appSize[0] * 0.95}px` : `${appSize[1] * 0.95}px`,
      width: appSize[0] < appSize[1] ? `${appSize[0] * 0.95}px` : `${appSize[1] * 0.95}px`,
      display: 'grid',
      gridTemplate: 'repeat(12, 1fr) / repeat(12, 1fr)'
    }

    useEffect(()=> {
      setCharPos(laberinto.start);
      setLaberintoObjects([
        laberinto.obj1,
        laberinto.obj2,
        laberinto.obj3,
        laberinto.obj4,
        laberinto.obj5,
        laberinto.obj6
      ]);
    }, [laberinto])

    useEffect(()=> {
      const objIndex = laberintoObjects.indexOf(charPos);
      if (objIndex !== -1){
        let copyOfLaberintoObjects = [...laberintoObjects];
        copyOfLaberintoObjects[objIndex] = null;
        setLaberintoObjects(copyOfLaberintoObjects);
        objFound(objectNames[objIndex]);
      }

      if (charPos === laberinto.goal && laberintoObjects.every(element => element === null)){
        onWin();
      }
      else if (charPos === laberinto.goal && !laberintoObjects.every(element => element === null)){
        setFaltanObjetos(true);
      }
      else{
        setFaltanObjetos(false);
      }

      // deshabilita el warning de dependencias en este caso
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [charPos, onWin, laberinto.goal, laberintoObjects, objFound])

    useEffect(() => {
      document.addEventListener('keydown', handleKeyDown);
      return () => {
        document.removeEventListener('keydown', handleKeyDown);
      };
      // deshabilita el warning de dependencias en este caso
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [charPos]);

    const handleBrickClick = (index) =>{
      if (index === charPos + 1){
        if (!board[charPos][1]){
          setCharPos(index);
        }
      }
      else if (index === charPos - 1){
        if (!board[charPos][3]){
          setCharPos(index);
        }
      }
      else if (index === charPos - 12){
        if (!board[charPos][0]){
          setCharPos(index);
        }
      }
      else if (index === charPos + 12){
        if (!board[charPos][2]){
          setCharPos(index);
        }
      }
    }

    const handleKeyDown = (e) => {
      if (e.code === "ArrowUp" && !board[charPos][0]){
        setCharPos(charPos - 12);
      }
      else if (e.code === "ArrowDown" && !board[charPos][2]){
        setCharPos(charPos + 12);
      }
      else if (e.code === "ArrowLeft" && !board[charPos][3]){
        setCharPos(charPos - 1);
      }
      else if (e.code === "ArrowRight" && !board[charPos][1]){
        setCharPos(charPos + 1);
      }
    }

    const handleSwiped = (eventData) => {
      // console.log(eventData.dir)
      // console.log(board[charPos])
      if (eventData.dir === "Up" && !board[charPos][0]){
        setCharPos(charPos - 12);
      }
      else if (eventData.dir === "Down" && !board[charPos][2]){
        setCharPos(charPos + 12);
      }
      else if (eventData.dir === "Left" && !board[charPos][3]){
        setCharPos(charPos - 1);
      }
      else if (eventData.dir === "Right" && !board[charPos][1]){
        setCharPos(charPos + 1);
      }
    }

    const swipehandlers = useSwipeable({
      onSwiped: handleSwiped,
      onTouchStartOrOnMouseDown: (({ event }) => event.preventDefault()),
      touchEventOptions: { passive: false },
      preventScrollOnSwipe: true,
      trackMouse: true
    });

    const defineContent = (index) =>{
      if(index === charPos && index === laberinto.goal){
        return 3;
      }
      else if (index === laberinto.goal){
        return 2;
      }
      else if(index === charPos) {
        return 1;
      }
      else if(index === laberintoObjects[0]) {
        return 4;
      }
      else if(index === laberintoObjects[1]) {
        return 5;
      }
      else if(index === laberintoObjects[2]) {
        return 6;
      }
      else if(index === laberintoObjects[3]) {
        return 7;
      }
      else if(index === laberintoObjects[4]) {
        return 8;
      }
      else if(index === laberintoObjects[5]) {
        return 9;
      }
      else{
        return 0;
      }
    }

  return (
    <div className='laberinto-board' style={ boardStyle } onKeyDown={handleKeyDown} { ...swipehandlers }>
      {board.map((brick, index) => (
            <Brick key={ index } 
                  id={ index } 
                  construction={ brick } 
                  content={defineContent(index)} 
                  brickClick={ handleBrickClick }
                  charSprite={ laberinto.personaje_sprite }
                  goalSprite={ laberinto.meta_sprite }
                  winSprite={ laberinto.win_sprite }
                  objSprite={ laberinto.objetos_sprite }
                  laberintoSprite={ laberinto.laberinto_sprite }
                  />
        ))}
        { faltanObjetos ? <TextGlobe 
          text={ pendingMsg } 
          position={ appSize[0] > appSize[1] ? appSize[1]/2 : appSize[0]/2 } 
          textSize={ appSize[0] > appSize[1] ? '2vw' : '2vh '} 
          /> : '' }
    </div>
  )
}

export default Board